import React from "react";
import {
    Box,
    Button,
    CircularProgress,
    Typography,
    Grid,
    Dialog,
    DialogActions,
    DialogContent,
    TextField,
} from "@mui/material";
import Rating from "@mui/material/Rating";
import { DatePicker } from "@mui/x-date-pickers";
import { AdminReviewsModel } from "../model/AdminReviewsModel";
import { CreateReviewDto, Review } from "../../../api/reviews/dto";
import dayjs from "dayjs";

export const AdminReviewsView: React.FC<AdminReviewsModel> = ({
                                                                  reviews,
                                                                  loading,
                                                                  error,
                                                                  onCreateOrUpdate,
                                                                  onDelete,
                                                                  onEdit,
                                                                  onAdd,
                                                                  isDialogOpen,
                                                                  onCloseDialog,
                                                                  currentReview,
                                                              }) => {
    const [localReview, setLocalReview] = React.useState<Review | CreateReviewDto>({
        name: "",
        content: "",
        rating: 5,
        date: new Date().toISOString(),
    });

    const MAX_CONTENT_LENGTH = 320;

    const truncateText = (text: string, maxLength: number) => {
        if (text.length <= maxLength) return text;
        return text.slice(0, maxLength) + "...";
    };

    React.useEffect(() => {
        if (currentReview) {
            setLocalReview(currentReview);
        } else {
            setLocalReview({
                name: "",
                content: "",
                rating: 5,
                date: new Date().toISOString(),
            });
        }
    }, [currentReview]);

    if (loading) return <CircularProgress />;
    if (error) return <Typography color="error">{error}</Typography>;

    return (
        <Box marginTop='30px'>
            <Button variant="contained" onClick={onAdd}>
                Добавить отзыв
            </Button>
            <Grid container spacing={2} marginTop={2}>
                {reviews.map((review) => (
                    <Grid item xs={12} sm={6} md={4} key={review.id}>
                        <Box
                            border="1px solid #ccc"
                            borderRadius="8px"
                            padding="16px"
                            height="310px"
                            display="flex"
                            flexDirection="column"
                            justifyContent="space-between"
                        >
                            <Typography variant="h5">{review.name}</Typography>
                            <Typography variant="body2" color="textSecondary">
                                {new Date(review.date).toLocaleDateString()}
                            </Typography>
                            <Rating value={review.rating} readOnly />
                            <Typography>{truncateText(review.content, MAX_CONTENT_LENGTH)}</Typography>
                            <Box marginTop="auto" display="flex">
                                <Button color="primary" onClick={() => onEdit(review)}>
                                    Редактировать
                                </Button>
                                <Button color="error" onClick={() => onDelete(review.id)}>
                                    Удалить
                                </Button>
                            </Box>
                        </Box>
                    </Grid>
                ))}
            </Grid>
            <Dialog open={isDialogOpen} onClose={onCloseDialog}>
                <DialogContent>
                    <TextField
                        fullWidth
                        label="Имя"
                        value={localReview.name}
                        onChange={(e) => setLocalReview({ ...localReview, name: e.target.value })}
                        margin="normal"
                    />
                    <TextField
                        fullWidth
                        label="Отзыв"
                        value={localReview.content}
                        onChange={(e) => setLocalReview({ ...localReview, content: e.target.value })}
                        margin="normal"
                        multiline
                        rows={4}
                    />
                    <Rating
                        value={localReview.rating}
                        onChange={(e, newValue) =>
                            setLocalReview({ ...localReview, rating: newValue || 5 })
                        }
                    />
                    <DatePicker
                        label="Дата"
                        value={localReview.date ? dayjs(localReview.date) : null}
                        onChange={(newDate) =>
                        setLocalReview({
                            ...localReview,
                            date: newDate ? newDate.toISOString() : localReview.date,
                        })
                    }
                        slotProps={{
                        textField: {
                            fullWidth: true,
                            margin: "normal",
                        },
                    }}
                        />

                </DialogContent>
                <DialogActions>
                    <Button onClick={onCloseDialog}>Отмена</Button>
                    <Button
                        onClick={() => onCreateOrUpdate(localReview)}
                        color="primary"
                        variant="contained"
                    >
                        Сохранить
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};
